import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-transfers',
  templateUrl: './stock-transfers.component.html',
  styleUrls: ['./stock-transfers.component.css']
})
export class StockTransfersComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public itemsListStockTransfers: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1056))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
    }

    private async loadStockTransfers() {
        if (!this.setting) return;

        this.itemsListStockTransfers = await this.datatask.Post(1057, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            case 'stockplace_id':
                this.loadStockTransfers();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        
        return Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadStockTransfers();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    filtervalue: string;
}
